// src/utils/api.js
import { swalError } from "./swalAlert";

export const fetchWithAuth = async (url, options = {}) => {
  try {
    const response = await fetch(url, { credentials: "include", ...options });

    if (response.status === 503) {
      try {
        const cloned = response.clone();
        const data = await cloned.json();
        if (data && (data.error === "MAINTAINANCE_MODE" || data.statusCode === 503)) {
          window.dispatchEvent(
            new CustomEvent("maintenance-mode-triggered", { detail: data })
          );
          return null;
        }
      } catch (err) {
        // Response was not JSON
      }
    }

    if (response.status === 401) {
      swalError("Session expired. Redirecting to login...", { timer: 5000, timerProgressBar: true });
      await new Promise(resolve => setTimeout(resolve, 5000));
      window.location.href = "/login"; // Redirect user
      return null; // Stop further execution
    }

    return response;
  } catch (error) {
    throw error; // Rethrow error for further handling
  }
};